module.exports = __webpack_public_path__ + "static/media/conveyor-belt.3dfc1ff1.svg";